// extracted by mini-css-extract-plugin
module.exports = {"overviewHRGraph":"hrOverviewCard_overviewHRGraph__2UVpr"};